import { RouteObject } from "react-router-dom";
import Index from "@/pages/Index";
import Settings from "@/pages/Settings";
import TeamManagement from "@/pages/TeamManagement";
import ContentCalendar from "@/pages/ContentCalendar";
import ContentCreation from "@/pages/ContentCreation";
import WebsiteManager from "@/pages/WebsiteManager";
import WebsiteSitemap from "@/pages/WebsiteSitemap";
import Organisation from "@/pages/Organisation";
import FreeCredits from "@/pages/FreeCredits";
import Admin from "@/pages/Admin";
import Media from "@/pages/Media";
import OnboardingChat from "@/pages/OnboardingChat";
import Chat from "@/pages/Chat";
import { TemplateRules } from "@/pages/TemplateRules";
import { SectionRules } from "@/pages/SectionRules";
import { ProtectedRoute } from "@/app/ProtectedRoute";
import Dashboard from "@/pages/Dashboard";
import PlannedContent from "@/pages/PlannedContent";
import Post from "@/pages/Post";
import ContentEditor from "@/pages/ContentEditor";

export const protectedRoutes: RouteObject[] = [
  {
    path: "dashboard",
    element: (
      <ProtectedRoute>
        <Index />
      </ProtectedRoute>
    ),
  },
  {
    path: "default",
    element: (
      <ProtectedRoute>
        <Dashboard />
      </ProtectedRoute>
    ),
  },
  {
    path: "calendar",
    element: (
      <ProtectedRoute>
        <ContentCalendar />
      </ProtectedRoute>
    ),
  },
  {
    path: "planned-content",
    element: (
      <ProtectedRoute>
        <PlannedContent />
      </ProtectedRoute>
    ),
  },
  {
    path: "post/:id",
    element: (
      <ProtectedRoute>
        <Post />
      </ProtectedRoute>
    ),
  },
  {
    path: "content-editor/:postThemeId",
    element: (
      <ProtectedRoute>
        <ContentEditor />
      </ProtectedRoute>
    ),
  },
  {
    path: "create",
    element: (
      <ProtectedRoute>
        <ContentCreation />
      </ProtectedRoute>
    ),
  },
  {
    path: "settings",
    element: (
      <ProtectedRoute>
        <Settings />
      </ProtectedRoute>
    ),
  },
  {
    path: "free-credits",
    element: (
      <ProtectedRoute>
        <FreeCredits />
      </ProtectedRoute>
    ),
  },
  {
    path: "organisation",
    element: (
      <ProtectedRoute>
        <Organisation />
      </ProtectedRoute>
    ),
  },
  {
    path: "team",
    element: (
      <ProtectedRoute>
        <TeamManagement />
      </ProtectedRoute>
    ),
  },
  {
    path: "team-management",
    element: (
      <ProtectedRoute>
        <TeamManagement />
      </ProtectedRoute>
    ),
  },
  {
    path: "websites",
    element: (
      <ProtectedRoute>
        <WebsiteManager />
      </ProtectedRoute>
    ),
  },
  {
    path: "sitemap",
    element: (
      <ProtectedRoute>
        <WebsiteSitemap />
      </ProtectedRoute>
    ),
  },
  {
    path: "media",
    element: (
      <ProtectedRoute>
        <Media />
      </ProtectedRoute>
    ),
  },
  {
    path: "onboarding-chat",
    element: (
      <ProtectedRoute>
        <OnboardingChat />
      </ProtectedRoute>
    ),
  },
  {
    path: "chat",
    element: (
      <ProtectedRoute>
        <Chat />
      </ProtectedRoute>
    ),
  },
  {
    path: "template-rules",
    element: (
      <ProtectedRoute>
        <TemplateRules />
      </ProtectedRoute>
    ),
  },
  {
    path: "template-rules/:websiteId",
    element: (
      <ProtectedRoute>
        <TemplateRules />
      </ProtectedRoute>
    ),
  },
  {
    path: "section-rules",
    element: <SectionRules />,
  },
  {
    path: "admin/*",
    element: <Admin />,
  },
];
